module.exports = __webpack_public_path__ + "static/btclassic-mac-screen-bc946a96f26803bc1f37fc35273fbfb0.jpg";